export interface MarkupBuilder {
  div(callback: (block: MarkupBuilder) => void): void

  span(callback: (block: MarkupBuilder) => void): void

  a(href: string, callback: (block: MarkupBuilder) => void): void

  attr(name: string, value: string): void

  text(text: string): void
}

export class MarkupBuilderImpl implements MarkupBuilder {
  constructor(readonly parent: HTMLElement) {
  }

  div(callback: (block: MarkupBuilder) => void): void {
    callback(new MarkupBuilderImpl(this._tag("div")))
  }

  span(callback: (block: MarkupBuilder) => void): void {
    callback(new MarkupBuilderImpl(this._tag("span")))
  }

  a(href: string, callback: (block: MarkupBuilder) => void): void {
    callback(new MarkupBuilderImpl(this._tag("a", { href })))
  }

  attr(name: string, value: string): void {
    this.parent.setAttribute(name, value)
  }

  text(text: string): void {
    const node = document.createTextNode(text)
    this.parent.appendChild(node)
  }

  renderToString(): string {
    return this.parent.innerHTML
  }

  private _tag(name: string, attrs: Record<string, string> = {}): HTMLElement {
    const node = document.createElement(name)
    for (const [key, value] of Object.entries(attrs)) {
      node.setAttribute(key, value)
    }

    this.parent.appendChild(node)
    return node
  }
}